<template>
<div>
    <h1 class="subtitle">Cambiar contraseña</h1>
    <div class="nj-panel" style="width: 400px; margin:  0 auto;">
        <div class="nj-panel-content">
            <div class="nj-flex-column">
                <InputText label="Contraseña actual" v-model="usu_old_password"></InputText>
                <InputText label="Contraseña nueva" v-model="usu_password"></InputText>
                <InputText label="Confirmar contraseña" v-model="confirm_password"></InputText>
            </div>
        </div>
        <div class="nj-panel-footer">
            <Button label="Cambiar" icon="save" color="green" @click="changePassword"></Button>
        </div>
    </div>
</div>
</template>

<script>
import { Button, InputText } from "../modules/components"
import { ResponseStatus, UsuarioService } from "../rest"
import Toast from "../util/toast"

export default {
    name: "ChangePassword",
    components: {
        Button,
        InputText,
    },
    data() {
        return {
            usu_old_password: '',
            usu_password: '',
            confirm_password: '',
        }
    },
    computed: {

    },
    methods: {
        changePassword() {
            if (this.usu_password === this.confirm_password) {
                const usuario = {
                    usu_password: this.usu_password,
                    usu_id: UsuarioService.getUsuario().usu_id
                }
                UsuarioService
                    .cambiarContraseña({
                        usuario
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            Toast.success(response.message)
                            this.usu_old_password = ""
                            this.usu_password = ""
                            this.confirm_password = ""
                        }
                        else {
                            Toast.warn(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })


            } else {
                Toast.error("Las Contraseñas no son identicas")
            }
        }
    }
}
</script>

<style scoped>
.form {
    width: 100%;
    height: calc(100vh - 25px - 65px - 24px - 12px);
    justify-content: center;
    align-items: flex-start;
    padding: 36px 0 0 0;
}
</style>
